export const handleLogout = () => {
  // Retrieve the token from localStorage.
  const id_token = localStorage.getItem("id_token");
  // Build the logout URL, including the id_token_hint if token exists.
    const idTokenHint = id_token ? `&id_token_hint=${encodeURIComponent(id_token)}` : "";
    const keycloakLogoutUrl =
      "https://ncjp.psanalytics.co.uk/auth/realms/ncjp/protocol/openid-connect/logout" +
      "?post_logout_redirect_uri=https://ncjp.psanalytics.co.uk/invite" + // Redirect after logout
      "&client_id=ncjp-app" + // Replace with your client ID if needed
      "&prompt=none" + 
      idTokenHint;

  console.log("Logging out...");

  // Clear session data.
  localStorage.clear();
  sessionStorage.clear();

  // Prevent back navigation after logout.
  window.history.pushState(null, "", window.location.href);
  window.history.replaceState(null, "", keycloakLogoutUrl);
  window.onpopstate = () => {
    window.history.pushState(null, "", keycloakLogoutUrl);
  };

  // Redirect to Keycloak logout URL.
  window.location.href = keycloakLogoutUrl;
};
